// apps/spa/src/components/reminders/TotalCharCounter.tsx
// Above-form counter showing 'X / 6,000 chars used'. Renders neutral muted
// text per CONTEXT Deferred (no red/yellow polish in v1). When total > max,
// surfaces a red warning text — the parent form's resolver also rejects via
// embedSchema's superRefine on path ['_total'] (defense in depth).

export interface TotalCharCounterProps {
  total: number;
  max: number;
}

export function TotalCharCounter({ total, max }: TotalCharCounterProps) {
  const exceeded = total > max;
  return (
    <div className="space-y-1">
      <p className="text-muted-foreground text-xs">
        {total.toLocaleString()} / {max.toLocaleString()} chars used
      </p>
      {exceeded && (
        <p className="text-destructive text-xs">
          Embed exceeds Discord's {max.toLocaleString()}-character limit.
        </p>
      )}
    </div>
  );
}
